'use client';

import { useMemo } from 'react';
import { trackWithCommonMetadata, TransformerMap } from './tracker';
import useAnalyticsCommonMetadataSession from './common-metadata/useAnalyticsCommonMetadataSession';
import useAnalyticsCommonMetadataUser from './common-metadata/useAnalyticsCommonMetadataUser';

type TruckSmarterAppUpsellAnalyticsEventMetadata = {
  APP_UPSELL_BANNER_RENDERED: Record<string, never>;
  APP_UPSELL_BANNER_DISMISSED: Record<string, never>;
  APP_UPSELL_BANNER_CTA_PRESSED: Record<string, never>;
  APP_UPSELL_DIALOG_RENDERED: Record<string, never>;
  APP_UPSELL_DIALOG_DISMISSED: Record<string, never>;
  APP_UPSELL_DIALOG_CTA_PRESSED: Record<string, never>;
};

/** Metadata transformers for each event, if applicable. */
const trailerTypesAnalyticsEventMetadataTransformers: TransformerMap<TruckSmarterAppUpsellAnalyticsEventMetadata> =
  {};

export default function useTrackAnalyticsEventTruckSmarterAppUpsell() {
  const sessionMetadata = useAnalyticsCommonMetadataSession();
  const userMetadata = useAnalyticsCommonMetadataUser();

  return useMemo(
    () =>
      trackWithCommonMetadata(
        [userMetadata, sessionMetadata],
        trailerTypesAnalyticsEventMetadataTransformers,
      ),
    [userMetadata, sessionMetadata],
  );
}
